import { Content } from "pdfmake/interfaces";
import getTitle from "report/common/title";

/**
 * 生成风险等级图例表格
 * @param legendTitle 图例标题
 * @param riskLevels 风险等级描述数组
 * @param isFutureHazard 是否为未来气候风险（6级颜色）
 * @returns 格式化后的表格内容
 */
function generateRiskLevelLegend(
  legendTitle: string,
  riskLevels: string[],
  isFutureHazard: boolean = false
): Content[] {
  // 通用的 5 级风险颜色（Climate Risk 和 CRS Component）
  const commonRiskStyles = [
    { fillColor: "#B5E6A2", color: "#275317" },
    { fillColor: "#DAF2D0", color: "#4EA72E" },
    { fillColor: "#FFFFCC", color: "#9C0006" },
    { fillColor: "#FFC7CE", color: "#9C0006" },
    { fillColor: "#CC0000", color: "#FFFFFF" }
  ];

  // futureHazard 的 6 级风险颜色（与前端页面一致）
  const futureHazardStyles = [
    { fillColor: "#b5e6a2", color: "#275317" },
    { fillColor: "#daf2d0", color: "#4ea72e" },
    { fillColor: "#ffffcc", color: "#9c0006" },
    { fillColor: "#F2AA84", color: "#9c0006" },
    { fillColor: "#ffc7ce", color: "#9c0006" },
    { fillColor: "#cc0000", color: "#ffffff" }
  ];

  const riskStyles = isFutureHazard ? futureHazardStyles : commonRiskStyles;

  // 确保风险等级和样式数量匹配
  const count = Math.min(riskLevels.length, riskStyles.length);

  // 生成表格行单元格
  const cells = [];
  for (let i = 0; i < count; i++) {
    cells.push({
      text: riskLevels[i],
      fillColor: riskStyles[i].fillColor,
      color: riskStyles[i].color,
      alignment: "center"
    });
  }

  return [
    getTitle(legendTitle, 9, "center"),
    {
      table: {
        headerRows: 1,
        widths: Array(count).fill("*"), // 平均分配宽度
        body: [cells]
      },
      layout: "noBorders",
      alignment: "center",
      pageBreak: "after",
      fontSize: 7,
      margin: [100, 0, 100, 0]
    }
  ];
}

export default generateRiskLevelLegend;
